<template>
  <div class="app-container">
    <!-- <el-header>  <el-col :span="24">重新计价</el-col></el-header> -->
    <el-main>
      <el-date-picker v-model="DocDateStart" value-format="yyyy-MM-dd" placeholder="开始日期"> </el-date-picker>

      <el-date-picker v-model="DocDateEnd" value-format="yyyy-MM-dd" placeholder="结束日期"> </el-date-picker>
      <el-button type="primary" class="btn" @click="add">重新计价</el-button>
      <div style="display: flex; justify-content: start; margin: 10px 0">
        <account-select
          v-model="GoodsName"
          :source="DAccount"
          @select="onSelect($event)"
          :pageSize="pageParams.pageSize"
          :pageIndex="pageParams.pageIndex"
          :listTotal="listTotal"
          @currentPage="currentPage($event)"
          @click.native="resetFun"
          @inputText="inputText($event)"
          :pageType="true"
        />
        <el-select v-model="WarehouseId">
          <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
        </el-select>
        <el-button type="primary" class="btn" @click="onStock">重算现存量</el-button>
      </div>
    </el-main>
  </div>
</template>
<script>
// import curdMixins from "@/mixins/curd";
import accountSelect from '@/components/sales/business/select'

export default {
  name: 'role',
  // mixins: [curdMixins],
  components: {
    accountSelect
  },
  data() {
    return {
      api: require('@/api/stock/costBook').default,
      stApi: require('@/api/stock/costBook').default,
      wareApi: require('@/api/ba/warehouse').default,
      account_api: require('@/api/goods/goods').default,
      DocDateStart: '',
      DocDateEnd: '',
      GoodsId: '',
      GoodsName: '',
      WarehouseId: '',
      wareList: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      DAccount: [],
      initDAccount: [],
      initTotal: 0
    }
  },
  mounted() {
    this.account_api.list({ Status: 1, pageIndex: 1, pageSize: 7 }).then(res => {
      if (res.Code == 0) (this.DAccount = res.Data), (this.initDAccount = res.Data), (this.initTotal = res.Count)
    })
    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.wareList = res.Data
    })
  },
  methods: {
    onStock() {
      this.stApi.RecountExistQuantity({ WarehouseId: this.WarehouseId, GoodsId: this.GoodsId }).then(res => {
        if (res.Code == 0) {
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
        loading.close()
      })
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage(val) {
      let GoodsName = this.GoodsName
      this.pageParams.pageIndex = val
      this.account_api.list({ Status: 1, pageIndex: val, pageSize: 7, GoodsName }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    inputText(text) {
      this.GoodsName = text
      this.account_api.list({ Status: 1, pageIndex: 1, pageSize: 7, GoodsName: text }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    currentPage(val) {
      let GoodsName = this.GoodsName
      this.pageParams.pageIndex = val
      this.account_api.list({ Status: 1, pageIndex: val, pageSize: 7, GoodsName }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    inputText(text) {
      this.GoodsName = text
      this.account_api.list({ Status: 1, pageIndex: 1, pageSize: 7, GoodsName: text }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    onSelect(e, row) {
      this.GoodsName = e.GoodsName
      this.GoodsId = e.GoodsId
    },
    add() {
      if (this.DocDateStart && this.DocDateEnd) {
        var loading = this.$loading({
          lock: true,
          text: '正在重新计价...',
          spinner: 'el-icon-loading',
          customClass: 'my_loading',
          background: 'rgba(0, 0, 0, 0.3)'
        })
        this.api
          .MathCost({
            DocDateStart: this.DocDateStart,
            DocDateEnd: this.DocDateEnd
          })
          .then(res => {
            if (res.Code == 0) {
              this.$message.success('保存成功')
            } else {
              this.$message.error('保存失败')
            }
            loading.close()
          })
      } else {
        this.$message.warning('请先选择月份')
      }
    }
  }
}
</script>
<style scoped>
.el-col {
  margin-bottom: 20px;
}
.btn {
  margin-left: 20px;
}
</style>
